import React from 'react'
import hash from 'object-hash'
import { RegisterUserInvitedView, ContractView } from '../../views'
import { ClientService, Auth0Service, LocalStorageService, UserService, AddressService, ContractService, MessageService } from '../../../services'
import { ValidateInputPure, MessagePure, SimpleLoading, UserInvitedInformationPure } from '../../pures'

import { PersonalInformation, PhoneValidation, TermsCondition } from '../../../assets/logos/icons'
import { useTranslation } from "react-i18next"

import { RegisterInvitedValidator } from '../../../validators'
import ChangePasswordAction from '../change-password/change-password.action'


/**
 * @class RegisterUserInvitedAction
 * @extends {React.Component}
 * @status no delete
 * @description Class describing the functionality and process of registration for the rinvited user
 */
class RegisterUserInvitedAction extends React.Component {
    constructor(props) {
        super(props)
    }
    input = React.createRef()

    state = {
        userId: '',
        clientId: '',
        userTypeId: '',
        languageId: '',
        email: '',
        contractBullets: [],
        loading: true,
        planChecked: false,
        showNotification: false,
        showLoadingRequesting: false,
        showCompletedRequesting: false,
        showErrorRequesting: false,
        redirectToChangePass: false,
        termnsAndConditions: false,
        modalTermsCond: false,
        step: 0,
        selectedStep: 0,
        invitedSteps: [
            { icon: PersonalInformation, itemElement: this.props.t('register.user.invited.action.personalInformationTitle'), itemSup: this.props.t('register.user.invited.action.nextLabel'), key: 'register.personalData', labelreturn: this.props.t('register.user.invited.action.close'), label: this.props.t('register.user.invited.action.personalData') },
            { icon: PhoneValidation, itemElement: this.props.t('registration.action.validation'), itemSup: this.props.t('registration.action.Steps.nextLaber'), key: 'register.address', labelreturn: this.props.t('registration.action.Steps.backLaber'), label: this.props.t('messagePure.validation') },
            { icon: TermsCondition, itemElement: this.props.t('register.user.invited.action.tos'), itemSup: this.props.t('register.user.invited.action.nextLabel'), key: this.props.t('register.user.invited.action.tos'), labelreturn: this.props.t('register.user.invited.action.backLabel'), itemMoral: this.props.t('register.user.invited.action.nextLabel'), label: this.props.t('register.user.invited.action.tos') },
        ],
        logo: null,
        validationCode: '',
        validationCodeCorrect: false,
        focused: false,
        eventId: '',
        accountId: 0,
        userUpdated: null,
        isLastStep: false,
        logo: null

    }

    token = {}
    user = {}
    url = process.env.REACT_APP_ETICKET_API
    localStorageService = new LocalStorageService()
    auth0Service = new Auth0Service()
    userService = new UserService(this.url)
    clientService = new ClientService(this.url)
    messageService = new MessageService(this.url)

    contractService = new ContractService(this.url)
    addressService = new AddressService(this.url)
    validator = RegisterInvitedValidator(this.props.t)
    invitedStepMetadata = [
        { number: 0, component: UserInvitedInformationPure },
        { number: 1, component: MessagePure },
        { number: 2, component: ContractView, action: 'validateContract' },
    ]

    /**
     * @author Martín Sánchez
     * @description Check if the contract is selected
     * @status no delete
     */
    validateContract = async () => {
        if (!this.state.termnsAndConditions) {
            await this.toggleErrorRequesting(true, this.props.t('register.user.invited.action.messageAcceptTos'))
            return false
        } else if (this.state.userTypeId === Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) && !this.state.planChecked) {
            await this.toggleErrorRequesting(true, this.props.t('register.user.invited.action.messagePlaseConfirm'))
            return false
        } else {
            return true
        }
    }

    componentDidMount = async () => {
        this.token = this.localStorageService.getLocalStorageItem('token').idToken
        this.user = this.localStorageService.getLocalStorageItem('user')

        let contractBullets = await this.contractService.getContractBullets(this.token)

        let userInformation = this.user.userMetaData.userA3Cloud
        let userInformationAkubicaFirmaDigital = this.user.userMetaData.userMifirma
        await this.localStorageService.setLocalStorageItem('clientLogo', '')
        let logo = await this.fetchClientImage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')


        return this.setState({
            userId: userInformation.id,
            userTypeId: userInformationAkubicaFirmaDigital.userType.id,
            languageId: userInformationAkubicaFirmaDigital.language.id,
            clientId: userInformation.clientId,
            email: userInformation.email,
            contractBullets,
            loading: false
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.termnsAndConditions !== this.state.termnsAndConditions) {
            if (this.state.termnsAndConditions) {
                let eventId = hash({ hash: Math.random().toString(36).substring(7) })
                this.setState({ eventId })
            }
        }
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the loading dialog modal
    * @date 22-10-2020
    * @status no delete
    * @memberof RegisterUserInvitedAction
    */
    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        })
    }


    /**
     * @description open term and conditions modal
     * @status no delete
     * @param {*} value
     * @memberof RegisterUserInvitedAction
     */
    openModalTermsCond = (value) => {
        this.setState({
            modalTermsCond: value
        });
    }


    /**
     * @status no delete
     * @return {*} 
     * @memberof RegisterUserInvitedAction
     */
    async fetchClientImage() {
        let result = await this.clientService.getClientImage(this.token)
        return result?.data?.image
    }

    /**
     * @description toggle the Accept terms and conditions checkbox
     * @status no delete
     * @memberof RegisterUserInvitedAction
     */
    onAcceptTermnsAndConditions = () => this.setState({ termnsAndConditions: !this.state.termnsAndConditions })

    /**
     * @description toggle the accept plan checkbox
     * @status no delete
     * @memberof RegisterUserInvitedAction
     */
    onAcceptPlan = () => this.setState({ planChecked: !this.state.planChecked })

    /**
    * @author Alan Aguilar
    * @description Method to show the complete request dialog modal
    * @date 22-10-2020
    * @status no delete
    * @memberof RegisterUserInvitedAction
    */
    toggleCompletedRequesting = (value) => {
        this.setState({
            showCompletedRequesting: value,
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showCompletedRequesting: false,
                        redirectToChangePass: true
                    })
                }, 4000)
            }
        )
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the Error request dialog modal
    * @date 22-10-2020
    * @status no delete
    * @memberof RegisterUserInvitedAction
    */
    toggleErrorRequesting = (value, message) => {
        this.setState({
            showErrorRequesting: value,
            message: message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showErrorRequesting: false,
                    })
                }, 4000)
            })
    }

    /**
* @author Alan Aguilar
* @description Method to show the WARNING dialog modal
* @status no delete
* @memberof SignatureRequestAction
*/
    toggleWarningRequesting = (value, message) => {
        this.setState({
            showWarningRequesting: value,
            message: message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showWarningRequesting: false,
                    })
                }, 4000)
            })
    }


    /**
     * @author Martín Sánchez
     * @description Close the modal after some time
     * @status no delete
     */
    handleMessage = () => {
        setTimeout(() => {
            this.onCloseOpenModal()
        }, 15000);
    }

    /**
     * @author Martín Sánchez
     * @description Close/Open the modal
     * @status no delete
     */
    onCloseOpenModal = () => this.setState({ showNotification: !this.state.showNotification })


    /**
     * @description change the step number that the user is on in the registration process.
     * @status no delete
     * @param {*} step
     * @memberof RegisterUserInvitedAction
     */
    changeStepNumber = (step) => {
        let stepLenght = this.state.invitedSteps.length - 1
        step = (step >= stepLenght) ? stepLenght : step + 1
        return step
    }

    /**
    * @author Alan Aguilar
    * @description Method to clear the localStorage and close the sesion
    * @date 22-10-2020
    * @status no delete
    * @memberof RegisterUserInvitedAction
    */
    onCloseSesion = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
    }


    /**
     * @description handles back step event
     * @status no delete
     * @param {*} event
     * @memberof RegisterUserInvitedAction
     */
    onBackStep = async (event) => {
        event.preventDefault()
        let stepNumber = this.stepBack(this.state.selectedStep)
        this.setState({ selectedStep: stepNumber })
    }

    /**
     * @description sets the correct number and event for when user takes back step
     * @status no delete
     * @param {*} step
     * @memberof RegisterUserInvitedAction
     */
    stepBack = (step) => {
        if (this.state.loading && step === 0) {
            this.setState({ selectedPersonType: false })
        } else if (step === 0) {
            this.setState({ selectedPersonType: false })
            this.handleButtonLogOut()
        } else {
            step = step - 1
        }
        return step
    }

    /**
     * @description handles the user logout
     * @status no delete
     * @memberof RegisterUserInvitedAction
     */
    handleButtonLogOut = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')

    }

    /**
    * @author Alan Aguilar
    * @description Hanlde method submit to make the petition in Mifirma-api
    * @date 22-10-2020
    * @status no delete
    * @memberof RegisterUserInvitedAction
    */
    onSubmitRegisterUserInvited = async (dataItem) => {
        let selectedStep = this.state.selectedStep
        let stepNumber = this.changeStepNumber(selectedStep)
        let action = this.invitedStepMetadata[selectedStep].action
        let result = true
        if (action) { // Only when the submit step requires an action the result is evaluated
            result = await this[action](dataItem)
            this.handleMessage()
        }

        if (result) { // When result its ok, we can flow to next steps
            if ((selectedStep === 0)) {
                let phoneNumber = dataItem.cellphoneNumber || this.state.cellphoneNumber
                this.setState({
                    cellphoneNumber: dataItem.cellphoneNumber
                })
                let message = await this.messageService.sendMessage(phoneNumber, false, this.token)
                if (!message.data) {
                    await this.toggleWarningRequesting(true, 'El número de teléfono celular proporcionado ya ha sido utilizado en otra cuenta.')
                    return false
                }
            }
            if ((selectedStep === 1)) {
                let phoneNumber = dataItem.cellphoneNumber || this.state.cellphoneNumber
                let validationCode = this.state.validationCode
                let codeValidator = await this.messageService.validateMessage(phoneNumber, validationCode, this.token)

                if (codeValidator.data) {
                    this.setState({
                        validationCodeCorrect: true
                    })
                } else {
                    await this.toggleWarningRequesting(true, 'Teléfono o mensaje Incorrectos.')
                    return false
                }
            }
            if (selectedStep === 2 && result) { // If we are in the last step then we save the data

                try {
                    await this.toggleLoadingRequesting(true)
                    let {
                        firstName,
                        secondLastName,
                        street,
                        externalNumber,
                        zipCode,
                        state,
                        firstLastName,
                        phoneNumber,
                        cellphoneNumber,
                        colony,
                        internalNumber,
                        township,
                        country,
                        rfc
                    } = dataItem

                    let {
                        clientId,
                        userTypeId,
                        languageId,
                        eventId,
                        termnsAndConditions
                    } = this.state

                    // Validate opcional data
                    cellphoneNumber = (cellphoneNumber === undefined || cellphoneNumber === '') ? ' ' : cellphoneNumber
                    phoneNumber = (phoneNumber === undefined || phoneNumber === '') ? ' ' : phoneNumber
                    street = (street === undefined || street === '') ? ' ' : street
                    externalNumber = (externalNumber === undefined || externalNumber === '') ? ' ' : externalNumber
                    internalNumber = (internalNumber === undefined || internalNumber === '') ? ' ' : internalNumber
                    zipCode = (zipCode === undefined || zipCode === '') ? '00000' : zipCode
                    colony = (colony === undefined || colony === '') ? ' ' : colony
                    township = (township === undefined || township === '') ? ' ' : township
                    state = (state === undefined || state === '') ? ' ' : state
                    country = (country === undefined || country === '') ? ' ' : country
                    rfc = (rfc === undefined || rfc === '') ? ' ' : rfc

                    this.token = this.localStorageService.getLocalStorageItem('token').idToken
                    let userData = { firstName, clientId, addressId: process.env.INVITED_ADDRESS_ID, firstLastName, secondLastName, phoneNumber, cellphoneNumber, userTypeId, languageId, rfc, termnsAndConditions, accountId: process.env.ACCOUNT_ID, eventId }
                    let userUpdated = await this.userService.updateUser(userData, this.token)
                    this.setState({ userUpdated, isLastStep: true })
                    if (!(Number(userUpdated.statusCode) === 200)) throw new Error('No se puedo completar la peticion')
                    await this.toggleLoadingRequesting(false)
                    await this.toggleCompletedRequesting(true)

                    return {
                        firstName,
                        secondLastName,
                        street,
                        externalNumber,
                        zipCode,
                        state,
                        firstLastName,
                        phoneNumber,
                        cellphoneNumber,
                        colony,
                        internalNumber,
                        township,
                        country,
                        rfc
                    }
                } catch (error) {
                    this.setState({ selectedStep: 1 })
                    await this.toggleLoadingRequesting(false)
                    await this.toggleErrorRequesting(true)
                    return false
                }
            }

            this.setState({ selectedStep: stepNumber })
        }
    }



    /**
     * @description resends the validation code to the user.
     * @status no delete 
     * @param {*} event
     * @memberof RegisterUserInvitedAction
     */
    onReSendMessage = async (event) => {
        event.preventDefault()
        let phoneNumber = this.state.cellphoneNumber
        let message = this.messageService.reSendMessage(phoneNumber, this.token)
        return message
    }

    //Button Validate input

    /**
     * @status no delete
     * @memberof RegisterUserInvitedAction
     */
    handleClick = () => {
        this.input.current.focus()
    }


    /**
     * @status no delete
     * @memberof RegisterUserInvitedAction
     */
    handleFocus = () => {
        this.setState({ focused: true })
    }


    /**
     * @status no delete
     * @memberof RegisterUserInvitedAction
     */
    handleBlur = () => {
        this.setState({
            focused: false,
        })
    }


    /**
     * @status no delete
     * @param {*} e
     * @memberof RegisterUserInvitedAction
     */
    handleChange = (e) => {
        const validationCode = e.target.value
        const CODE_LENGTH = new Array(6).fill(0)

        this.setState((state) => {
            if (state.validationCode.length >= CODE_LENGTH.length) return null
            return {
                validationCode: (state.validationCode + validationCode).slice(0, CODE_LENGTH.length),
            }
        })
    }


    /**
     * @description On "Backspace" key, removes a number from the validation code input
     * @status no delete
     * @param {*} e
     * @memberof RegisterUserInvitedAction
     */
    handleKeyUp = (e) => {
        if (e.key === "Backspace") {
            this.setState((state) => {
                return {
                    validationCode: state.validationCode.slice(0, state.validationCode.length - 1),
                }
            })
        }
    }

    render() {
        if (this.state.loading) {
            return <SimpleLoading />
        } else {
            if (this.state.redirectToChangePass === false) {
                return (
                    <RegisterUserInvitedView
                        {...this.state}
                        isLastStep={this.state.isLastStep}
                        goToApp={async () => { await this.toggleCompletedRequesting(true) }}
                        validator={this.validator}
                        validateInput={ValidateInputPure}
                        onSubmitRegisterUserInvited={this.onSubmitRegisterUserInvited}
                        onCloseSesion={this.onCloseSesion}
                        onChangeUserPassword={this.onChangeUserPassword}
                        onAcceptTermnsAndConditions={this.onAcceptTermnsAndConditions}
                        contractBullets={this.state.contractBullets}
                        toggleLoadingRequesting={this.toggleLoadingRequesting}
                        toggleCompletedRequesting={this.toggleCompletedRequesting}
                        toggleErrorRequesting={this.toggleErrorRequesting}
                        toggleWarningRequesting={this.toggleWarningRequesting}
                        steps={this.state.invitedSteps}
                        onAcceptPlan={this.onAcceptPlan}
                        onChangeStep={this.onChangeStep}
                        stepMetadata={this.invitedStepMetadata}
                        onSubmitClick={this.onSubmitClick}
                        onBackStep={this.onBackStep}
                        openModalTermsCond={this.openModalTermsCond}

                        onReSendMessage={this.onReSendMessage}
                        handleClick={this.handleClick}
                        handleFocus={this.handleFocus}
                        handleBlur={this.handleBlur}
                        handleChange={this.handleChange}
                        handleKeyUp={this.handleKeyUp}

                        input={this.input}

                    />
                )
            } else {
                return (<ChangePasswordAction
                    {...this.state}
                />)
            }
        }
    }
}


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
function RegisterUserInvitedActionContainer(props) {
    const { t } = useTranslation()
    return (
        <RegisterUserInvitedAction {...props} t={t} />
    )
}


export { RegisterUserInvitedActionContainer as default }